"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentCompleteProvider = void 0;
const domain_1 = require("../../../domain");
const lodash_1 = __importDefault(require("lodash"));
const rxjs_1 = require("rxjs");
class AssignmentCompleteProvider {
    constructor(contentProvider, metaProvider, settingsProvider, teacherEntryProvider) {
        this.contentProvider = contentProvider;
        this.metaProvider = metaProvider;
        this.settingsProvider = settingsProvider;
        this.teacherEntryProvider = teacherEntryProvider;
    }
    async data(id) {
        const [content, meta, settings, teacherEntry] = await Promise.all([
            this.contentProvider.content(id),
            this.metaProvider.meta(id),
            this.settingsProvider.settings(id),
            this.teacherEntryProvider.entry(id),
        ]);
        return domain_1.AssignmentComplete.from(content, meta, settings, teacherEntry);
    }
    dataStream(id) {
        return (0, rxjs_1.combineLatest)(this.contentProvider.contentStream(id), this.metaProvider.metaStream(id), this.settingsProvider.settingsStream(id), this.teacherEntryProvider.entryStream(id), (content, meta, settings, teacherEntry) => domain_1.AssignmentComplete.from(content, meta, settings, teacherEntry));
    }
    async dataFromMetas(metas) {
        const results = await Promise.all(metas.map(async (meta) => {
            const [content, settings, teacherEntry] = await Promise.all([
                this.contentProvider.content(meta._id),
                this.settingsProvider.settings(meta._id),
                this.teacherEntryProvider.entry(meta._id),
            ]);
            return domain_1.AssignmentComplete.from(content, meta, settings, teacherEntry);
        }));
        return lodash_1.default.compact(results);
    }
    /** tries to find any meta for the given lesson and group where the teacher is the owner or has been shared with */
    async latestDataByLessonInGroup(lessonId, teacherId, groupId, type) {
        const meta = await this.metaProvider.latestMetaByLessonInGroup(lessonId, groupId, teacherId, type);
        if (!meta)
            return undefined;
        const [content, settings, teacherEntry] = await Promise.all([
            this.contentProvider.content(meta._id),
            this.settingsProvider.settings(meta._id),
            this.teacherEntryProvider.entry(meta._id),
        ]);
        return domain_1.AssignmentComplete.from(content, meta, settings, teacherEntry);
    }
}
exports.AssignmentCompleteProvider = AssignmentCompleteProvider;
//# sourceMappingURL=AssignmentCompleteProvider.js.map